import { computed } from "vue";
import { useStore } from "vuex";

export default {
    name: "WebshopHeader",
    setup() {
        const store = useStore();

        const initialItemsCount = computed(
            () => store.state.basket?.initialItemsCount,
        );

        const itemsCount = computed(
            () =>
                store.state.basket?.totals?.productsAmount ||
                initialItemsCount.value,
        );
        const itemsCountString = computed(() =>
            itemsCount.value > 99 ? "99+" : itemsCount.value.toString(),
        );
        const startBurgermenu = function (e) {
            console.log("burger icon clicket");
            store.dispatch("main/openPageOverlay", {
                overlayContent: "BurgerMenu",
                returnTarget: e.currentTarget,
            });
        };

        const startSearchoverlay = function (e) {
            store.dispatch("main/openPageOverlay", {
                overlayContent: "SearchOverlay",
                returnTarget: e.currentTarget,
            });
        };

        const startMegaMenu = function (e) {
            store.dispatch("main/openPageOverlay", {
                overlayContent: "megaMenu",
                returnTarget: e.currentTarget,
            });
        };

        const startProfileOverlay = function (e) {
            store.dispatch('main/openPageOverlay', {
                overlayContent: 'ProfileOverlay',
                returnTarget: e.currentTarget
            })
        }


        return {
            itemsCount,
            itemsCountString,
            startBurgermenu,
            startSearchoverlay,
            startMegaMenu,
            startProfileOverlay
        };
    },
};
